import {createContext} from 'react';

export type TState = {
    text: string;
    setEditing?: () => void;
    handleCollapse?: () => void;
    isEditing?: boolean;

}

const InitialState = {
    text: '',
    isEditing: false,
    setEditing: () => {},
    handleContextCollapse: () => {},
};

export const RequestCardContext = createContext<TState>(InitialState);
